import React from 'react';
import { Typography } from 'antd';
import AlumlyBreadCrumb, { PathT } from '../../../components/AlumlyBreadCrumb';
import { RouteNameEnum } from '../../../enums/routeName';
import FormEvent from '../components/FormEvent';

const { Title } = Typography;

const CreateEvent: React.FC = () => {
  const path: PathT[] = [
    { label: 'Events', value: RouteNameEnum.event.index },
    { label: 'Create event', value: RouteNameEnum.event.create },
  ];

  return (
    <div>
      <AlumlyBreadCrumb path={path} />
      <Title level={4} style={{ fontWeight: 'bold' }}>Create Event</Title>
      <FormEvent mode="create" />
    </div>
  );
};

export default CreateEvent;
